import { FC } from "react";
import styles from "./TableHead.module.sass";

export const TableHead: FC = () => {
	const headList = ["№", "Код", "Наименование", "Тип объекта", "Сфера деятельности объекта", "Номер фстэк"];

	return (
		<table className={styles["table-head"]}>
			<thead className={styles.head}>
				<tr className={styles.row}>
					{headList.map((headItem, i) => (
						<th key={i} className={styles.item}>
							{headItem}
						</th>
					))}
				</tr>
			</thead>
		</table>
	);
};
